import axiosInstance from "./config";

const basePath = `/induk-app/brands`;

export const getBrands = (page?: number, search?: string) => {
  return axiosInstance.get(`${basePath}`, {
    params: {
      page,
      search,
    },
  });
};

export const addBrand = (category: {
  image: File | null;
  name: string;
  description: string | null;
}) => {
  const formData = new FormData();
  Object.entries(category).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value);
  });

  return axiosInstance.post(`${basePath}/create`, formData);
};

export const getBrand = (slug: string) => {
  return axiosInstance.get(`${basePath}/${slug}`);
};

export const updateBrand = (
  slug: string,
  category: {
    image: File | null;
    name: string;
    description: string | null;
  }
) => {
  const formData = new FormData();
  Object.entries(category).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    formData.append(key, value);
  });

  return axiosInstance.patch(`${basePath}/${slug}/update`, formData);
};

export const deleteBrand = (slug: string) => {
  return axiosInstance.delete(`${basePath}/${slug}/delete`);
};
